<template>
  <div class="professor-root-container">
    <van-overlay :show="loading" @click="loading = false" style="z-index:12">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" class="row" style="align-items:center" />
      </div>
    </van-overlay>
    <navigation-bar title="评审专家" />
    <div class="professor-container" style="margin-top: 0.68rem; padding: 0.15rem">
      <div class="professor-list column">
        <div class="professor-item-container row" v-for="item in professorList" :key="item.id"
          style="align-items: flex-start">
          <div class="professor-img div-background" :style="{
              backgroundImage: `url(${item.fullPath})`,
            }"></div>
          <div class="column" style="flex: 1; margin-left: 0.1rem">
            <div class="professor-name">{{ item.name }}</div>
            <div class="professor-desc" style="margin-top: 0.05rem">
              {{ item.more }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import NavigationBar from "@/components/NavigationBar";

export default {
  components: {
    "navigation-bar": NavigationBar,
  },
  data() {
    return {
      loading: true,
      portfolio_id: 0,
      professorList: [],
    };
  },
  mounted() {
    this.portfolio_id = this.$router.currentRoute.params.portfolio_id;

    this.getProfessorList();
  },
  methods: {
    ...mapActions({
      portfolioGetProfessorAction: "portfolioGetProfessor",
    }),
    getProfessorList() {
      this.portfolioGetProfessorAction({
        portfolio_id: this.portfolio_id,
      })
        .then((res) => {
          this.professorList = res;
        })
        .catch((error) => {
          console.error(error);
          alert(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.professor-list {
  background-color: #f9f9f9;
  width: calc(100vw - 0.3rem);
}
.professor-item-container {
  width: 100%;
  padding: 0.1rem;
  background-color: white;
  box-sizing: border-box;
}
.professor-img {
  width: 1rem;
  height: 1rem;
}
.professor-name {
  font-family: PingFangSC-Semibold;
  font-size: 0.18rem;
  color: #282828;
  text-align: justify;
}
.professor-desc {
  font-family: PingFangSC-Regular;
  font-size: 0.12rem;
  color: #282828;
  text-align: justify;
}
</style>